import { ChangeDetectorRef, Component, HostBinding, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { LoadingService } from './loading.service';
import { SubscribedComponent } from '../../../lib/subscribed.component';
import { takeUntil } from 'rxjs';
import { NzSpinComponent } from 'ng-zorro-antd/spin';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NzSpinComponent],
})
export class LoadingComponent extends SubscribedComponent implements OnInit {
  @HostBinding('class.is-visible')
  loading: boolean = false;

  constructor(
    private loadingService: LoadingService,
    private cdRef: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.loadingService
      .watchLoading()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((loading) => {
        // Defer the update to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.loading = loading;
          this.cdRef.markForCheck();
        });
      });
  }
}
